import { Pipe, PipeTransform } from '@angular/core';
import { InstallerTeamLead, isInstallerLead, User } from '~gc/domains/users/user/user.model';

@Pipe({ name: 'asInstallerTeamLead' })
export class AsInstallerTeamLeadPipe implements PipeTransform {
  transform(user: User): InstallerTeamLead | undefined {
    return isInstallerLead(user) ? user : undefined;
  }
}
